import { getFilePrecacheAll, get_5_0_UrlAll, getUniqueUrlAll } from './file-precache/index';
import request from '@/natives/libs/request';

(async function () {
  const dlls = JSON.parse(process.env.dlls || '[]') as string[];
  dlls.forEach((dllName: string) => {
    const el = document.createElement('link');
    el.href = `/Common/dlls/${dllName}.dll.js`;
    el.rel = 'prefetch';
    document.head.appendChild(el);
  });
  const fileUrlManifest: string[] = getFilePrecacheAll();
  const uniquePackageUrlManifest: string[] = getUniqueUrlAll();
  const fiveDotZeroUrlManifest: string[] = await get_5_0_UrlAll();
  // 5.0的包直接用iframe链接入口文件--index.html里的link标签为首屏资源。
  // 可能的问题，对应配置包的link标签不是prefetch，测试下来会阻塞落地页的图片资源几秒钟（约六秒）
  // 更新：取云端index.html的内容，拿到script的内容，拼接上prefetch后再补充到我们的head里，解决阻塞问题
  fiveDotZeroUrlManifest.forEach((url) => {
    const el = document.createElement('link');
    el.href = url;
    el.rel = 'prefetch';
    document.head.appendChild(el);
  });
  // 4.0的包直接用link标签预取资源
  fileUrlManifest.forEach((url) => {
    const el = document.createElement('link');
    el.href = url;
    el.rel = 'prefetch';
    document.head.appendChild(el);
  });
  // 此处补充特意目录的资源，如批量模板配置中使用的配置包资源
  uniquePackageUrlManifest.forEach((url) => {
    const el = document.createElement('link');
    el.href = url;
    el.rel = 'prefetch';
    document.head.appendChild(el);
  });

  // 请求hpc的入口清单，预加载hpc
  request.get('/installer/prefetch-home-list.json').then((resp) => {
    const hpcHome: string[] = resp[2]?.data?.urls;
    hpcHome.forEach((url) => {
      const el = document.createElement('link');
      el.href = url;
      el.rel = 'prefetch';
      document.head.appendChild(el);
    });
  });
  // 请求hpc的入口清单，预加载hpc
  request.get('/installer/prefetch-main-list.json').then((resp) => {
    const hpcManifest: string[] = resp[2]?.data?.urls;
    hpcManifest.forEach((url) => {
      const el = document.createElement('link');
      el.href = url;
      el.rel = 'prefetch';
      document.head.appendChild(el);
    });
  });
})();
